import { CINZA_ESC, TEXTO, BORDA_FORTE, RAIO, ESP, BRANCO } from "../tema";

// Estilo único de campo, para o painel inteiro.
//
// Existia um estilo em Input.js, outro em Sel.js, e mais um escrito à mão em
// quase toda tela que precisou de um campo de data ou de um número. A
// diferença entre eles é pequena e é exatamente por isso que incomoda: o
// olho percebe que não estão alinhados sem saber dizer por quê.
export const ESTILO_CAMPO = {
  border: `1px solid ${BORDA_FORTE}`,
  borderRadius: RAIO.md,
  padding: "10px 12px",
  fontSize: 13.5,
  fontFamily: "inherit",
  color: TEXTO,
  background: BRANCO,
  outline: "none",
  boxSizing: "border-box",
};

// Rótulo de campo. Discreto e sempre acima, nunca dentro do campo: rótulo
// que só vive de placeholder some assim que se começa a digitar, e quem
// preenche formulário longo perde a referência.
export function Rotulo({ children, style = {} }) {
  return (
    <label style={{ fontSize: 12.5, fontWeight: 600, color: CINZA_ESC, ...style }}>
      {children}
    </label>
  );
}

// Campo com rótulo. Aceita qualquer type de input e também data.
export default function Campo({
  label, value, onChange, type = "text", placeholder = "",
  min, max, list, disabled, style = {}, onKeyDown, dica,
}) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: ESP.xs, ...style }}>
      {label && <Rotulo>{label}</Rotulo>}
      <input
        type={type} value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder} onKeyDown={onKeyDown}
        min={min} max={max} list={list} disabled={disabled}
        style={{ ...ESTILO_CAMPO, width: "100%" }}
      />
      {dica && (
        <div style={{ fontSize: 11.5, color: CINZA_ESC, lineHeight: 1.5 }}>{dica}</div>
      )}
    </div>
  );
}
